var exports = {};
exports.generateTable = function(stringData, rowSize) {
    var rows = stringData.split("\n");

    var table = []

    for(var y in rows) {
        var cells = rows[y].split("\t");
        var row = []
        for(var x in cells) {
            var cell = cells[x].trim()
            if(cell != "") row.push(cell);
        }
        if(!rowSize || rowSize == row.length){
            table.push(row);
        }
    }
    return table
}
export default exports